import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import LoadingForm from './../components/form/LoadingForm';

const EmailTagInput = React.lazy(() => import('./../components/form/EmailTagInput'));
const EmailRecipientsEditor = React.lazy(() => import('./../components/form/email/EmailRecipientsEditor'));

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.email-tag-input').forEach(node =>
    createRoot(node).render(
      <Suspense fallback={<LoadingForm />}>
        <EmailTagInput {...Object.assign({}, node.dataset)} />
      </Suspense>
    )
  );

  document.querySelectorAll('.email-recipients-editor').forEach(node =>
    createRoot(node).render(
      <Suspense fallback={<LoadingForm />}>
        <EmailRecipientsEditor {...Object.assign({}, node.dataset)} />
      </Suspense>
    )
  );
});
